export default {
    currentDocumentName: 'BnF Ms. Fr. 640',
    manifestURL: `${process.env.REACT_APP_EDITION_DATA_URL}/manifest.json`,
    folios: [],
    loaded: false,
    folioIndex: [],
	folioNameByIDIndex:{},
	folioIDByNameIndex:{}
}	